export const getFlatPages = () => {
  return `query flats {
        flats: flatList{
          id
          url,
          titleFr
          titleEn
          contentFr
          contentEn
        }
      }`
}

export const getFlatPageBySlug = () => {
  return `query getFlatPageBySlug($slug: String!) {
        flatBySlug(slug: $slug) {
          id
          url,
        titleFr
        titleEn
        contentFr
        contentEn
          }
        }`
}
